// populates missing values
module.exports = function(dst, src) {

  Object.keys(src).forEach(function(prop)
  {
    dst[prop] = dst[prop] || src[prop];
  });

  return dst;
};



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/populate.js
// module id = 812
// module chunks = 0